export const ibanBelongsToBanksGermany = (
  iban: string,
  bankleitzahlen: string[],
): boolean => {
  const ibanBankIdentifier = iban.substring(4, 12);

  return bankleitzahlen.includes(ibanBankIdentifier);
};
